<template lang="pug">
    v-dialog(v-model="dialog" content-class="haq-dialog" max-width="65%" @input="onDialogInput" scrollable)
        v-card#alert-dialog.haq-dialog-card
            v-card-title.haq-dialog-card-header
                //- v-icon.alerts-icon mdi-bell-outline
                .haq-dialog-card-title 
                    span Active Alerts
                    span.ml-6(v-if="resolvedSite")
                        a(:href="'/projects/'+resolvedSite.project.objectId+'/sites/'+resolvedSite.objectId+'/alerts'")
                            v-btn.haq-btn.haq-btn-primary(@click="closeModal") See All Alerts
                v-spacer
                v-icon.close-icon(text @click="closeModal") mdi-close
            v-card-text
                .no-alerts(v-if="loading") Loading alerts…
                .alerts(v-else-if="alerts && alerts.length > 0 && resolvedSite")
                    .alert(v-for="(n,index) in pages" :key="n.objectId")
                        .alert-header
                            v-icon.warning-icon(:class="(n.alertConfig.alertType == 'warning' ? 'alert-warning' : 'alert-critical')") mdi-alert
                            //- v-icon.warning-icon(:class="(n.alertType == 'warning' ? 'alert-warning' : 'alert-critical')") mdi-alert-octagram
                            .alert-title 
                                a(:href="'/projects/'+resolvedSite.project.objectId+'/sites/'+resolvedSite.objectId+'/zones/'+n.measurement.zone.objectId") {{n.measurement.zone.name}} - {{n.measurement.name}}
                            v-spacer
                            //- v-icon.dismiss-alert(text @click="dismissAler") mdi-close
                        .alert-triggered-time 
                            span Triggered at {{ formatTime(n.createdAt) }}
                        .alert-message {{n.alertConfig.message}}
                            //- a(:href="'/projects/'+resolvedSite.project.objectId+'/sites/'+resolvedSite.objectId+'/zones/'+n.measurement.zone.objectId") {{n.measurement.zone.name}} - {{n.measurement.name}}
                        //- .alert-notes {{n.notes}}
                .no-alerts(v-else-if="loadError") {{ loadError }}
                .no-alerts(v-else) You have no active alerts.
            v-card-actions(v-if="alerts && alerts.length > 0")
                v-pagination.haq-alerts-paging(v-model="currentPage" :length="Math.ceil(alerts.length/pageMax)" :total-visible="7" color="notprimary")

                                
</template>
<script>
import { useGetSite } from '../../assets/js/hawken-query'
// import {HTTPClient} from '../../assets/js/http'
// let client = new HTTPClient();

export default {
    name: 'Alerts',
    props: {
        openModal: String,
        alerts: Array,
        /** Site id from Navbar (route params are missing on Virtual Edge / Devices). */
        siteId: String,
        /** Optional site object already loaded by the parent page. */
        site: Object,
    },
    data() {
        return {
            dialog: this.openModal == 'alerts' ? true : false,
            currentPage: 1,
            pageMax: 5,
            resolvedSite: null,
            loading: true,
            loadError: null,
        }
    },
    created() {
        this.resolvedSite = this.site || null;
        this.loading = !this.resolvedSite;
    },
    methods: {
        /**
         * Close only when the dialog value becomes false (ignore open=true input).
         * @param {boolean} val
         */
        onDialogInput(val) {
            if (!val) this.closeModal();
        },
        closeModal() {
            this.dialog = false;
			this.$emit("closeModal")
		},
        /**
         * Resolve site id from prop, route params, or query.
         * @returns {string|null}
         */
        resolveSiteId() {
            return this.siteId
                || this.$route.params.siteId
                || this.$route.query.siteId
                || null;
        },
        /**
         * Load site for alert links when parent did not pass one.
         */
        async loadAlerts(){
            if (this.resolvedSite) {
                this.loading = false;
                return;
            }
            const id = this.resolveSiteId();
            if (!id) {
                this.loading = false;
                this.loadError = 'No site selected.';
                return;
            }
            this.loading = true;
            this.loadError = null;
            try{
                this.resolvedSite = await useGetSite(id);
                if (!this.resolvedSite) {
                    this.loadError = 'Could not load site.';
                }
            }catch(e){
                console.error(e)
                this.loadError = 'Could not load site.';
            } finally {
                this.loading = false;
            }
        },
        /**
         * Format timestamp for display
         * @param {string} timestamp - ISO timestamp string
         * @returns {string} Formatted date and time
         */
        formatTime(timestamp) {
            if (!timestamp) return 'Unknown';
            const date = new Date(timestamp);
            return date.toLocaleDateString() + ' at ' + date.toLocaleTimeString();
        }
    },
    computed: {
        pages () {
            if(!this.alerts)
                return []
            return this.alerts.slice((this.currentPage - 1) * this.pageMax, this.currentPage * this.pageMax)
        }
    },
    mounted(){
        this.loadAlerts()
    }
}
</script>
<style lang="sass">
    #alert-dialog
        .haq-dialog-card-header
            padding-bottom: 34px !important
            .alerts-icon
                font-size: 34px !important
                margin-right: 15px
            .haq-dialog-card-title
                font: 400 34px/46px 'Roboto'

    .alerts
        display: flex
        flex-direction: column
        gap: 16px
        width: 100%
        .alert
            background: var(--app-secondary-bg)
            border-radius: 12px
            display: block
            padding: 16px
            .alert-header
                display: flex
                flex-direction: row
                justify-content: left
                margin-bottom: 5px
                .warning-icon
                    margin-right: 10px
                    &.alert-warning
                        color: var(--score-yellow-color)
                    &.alert-critical
                        color: var(--score-red-color)
                .alert-title
                    color: var(--app-primary-txt)
                    font: 400 20px/24px 'Roboto'
                    letter-spacing: 0.18px
            .alert-triggered-time
                margin-bottom: 8px
                color: var(--app-secondary-txt)
                font: 400 14px/20px 'Roboto'
            .alert-message
                color: #fff
                font: 400 16px/24px 'Roboto'
    .no-alerts
        font: 400 18px/24px 'Roboto'
        margin: 50px auto
        text-align: center
        width: 100%
    .haq-alerts-paging
        box-shadow: none
        height: auto
        line-height: 24px
        width: 100%
        i
            height: auto
        .v-pagination__navigation
            background: transparent !important
            box-shadow: none
            color: var(--app-primary-txt)
        .v-pagination__item
            background: transparent !important
            box-shadow: none
            color: var(--app-primary-txt)
        .v-pagination__item--active
            background: transparent
            border: 1px solid var(--app-primary-txt)

    .haq-btn
        border-radius: 12px !important
        padding: 8px 24px !important
        font-weight: 500 !important
        text-transform: none !important
        min-width: 100px !important
        height: 2.8em !important
        line-height: 2.8em !important
        
        &.haq-btn-primary
            background: var(--score-blue-color) !important
            color: white !important
            
            &:hover
                background: var(--score-blue-color) !important
                opacity: 0.9 !important
                
            &:disabled
                background: var(--app-tertiary-bg) !important
                color: var(--app-tertiary-txt) !important
                opacity: 0.6 !important
</style>
